// https://developers.google.com/web/fundamentals/app-install-banners
const checkIsInStandaloneMode = () => {
  if (!__CLIENT__) {
    return false;
  }
  // @ts-expect-error navigator.standalone only works for iOS
  const safariCheck: boolean = !!window.navigator.standalone;
  const mediaQueryCheck: boolean = !!window.matchMedia('(display-mode: standalone)').matches;

  return safariCheck || mediaQueryCheck ? 1 : 0;
};

export default checkIsInStandaloneMode();
